<template>
  <div id="target" v-if="isAdmin">
    <div class="form-row">
      <h3>Municipality Messages</h3>
    </div>
    <div style="text-align: left; padding: 1px">
        <ejs-button
          type="button"
          cssClass="e-info"
          v-on:click.native="onNewMunicipalityMessageClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
          New Municipality Messages
        </ejs-button>
      </div>
    <ejs-grid
      :dataSource="muniMessages"
      ref="refEmailStage"
      :allowSorting="true"
      :allowPaging="true"
      :pageSettings="pageSettings"
      :toolbar="toolbarOptions"
      :created="created"
      enablePersistence="true"
      :commandClick="commandClick"
      :allowTextWrap="false"
      :textWrapSettings="wrapSettings"
    >
      <e-columns>
        <e-column headerText="Details" width="8%" textAlign="Left" :commands="commands"></e-column>
        <e-column
          field="id"
          headerText="ID"
          textAlign="Left"
          :isPrimaryKey="true"
          width="0"
        ></e-column>
        <e-column
          field="muniName"
          width="20%"
          headerText="Municipality Name"
          textAlign="Left"
        ></e-column>
        <e-column field="muniCode" width="8%" headerText="Code" textAlign="Left"></e-column>
        <e-column field="accreditationNumber" width="15%" headerText="Accreditation Number" textAlign="Left"></e-column>
        <e-column
          field="whereToGetPermit"
          width="50%"
          :disableHtmlEncode="false"
          clipMode="EllipsisWithTooltip"
          headerText="Message"
          textAlign="Left"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import { FETCH_MUNICIPALITY_MESSAGES } from '../store';

Vue.use(GridPlugin);

export default {
  name: 'MunicipalityMessages',
  data() {
    return {
      commands: [
        {
          type: 'Edit',
          buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' },
        },
      ],
      toolbarOptions: ['Search'],
      pageSettings: { pageSize: 10 },
      target: '#target',
      wrapSettings: { wrapMode: 'Content' },
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
      muniMessages: 'getMunicipalityMessages',
    }),
  },
  mounted() {
    if (this.$refs.refEmailStage) {
      this.$refs.refEmailStage.ej2Instances.searchSettings.key = '';
    }
  },
  created() {
    if (this.loggedUser) {
      this.checkUserRole(this.loggedUser.roles.map((x) => x.roleName));
    }
  },
  watch: {
    loggedUser(loggedUser) {
      this.checkUserRole(loggedUser.roles.map((x) => x.roleName));
    },
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refEmailStage) {
        document
          .getElementById(`${this.$refs.refEmailStage.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.refEmailStage.$el.id);
          });
      }
    },
    onNewMunicipalityMessageClick() {
      this.$router.push('/municipality-message-edit/null');
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    checkUserRole(roles) {
      this.isAdmin = roles.includes('Admin') || roles.includes('SuperAdmin');
      if (this.isAdmin) this.$store.dispatch(FETCH_MUNICIPALITY_MESSAGES);
    },
    notify(type, message) {
      this.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    commandClick(args) {
      if (args.commandColumn.type === 'Edit') {
        this.$router.push(`/municipality-message-edit/${args.rowData.muniCode}`);
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}
.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
</style>
